/**
 * Uncomment this only if you have js functionality for the component
 * 
 */

// If element is in viewport
function isInViewport(el) {
    var elementTop = el.offset().top;
    var elementBottom = elementTop + el.outerHeight();
    var viewportTop = jQuery(window).scrollTop();
    var viewportBottom = viewportTop + jQuery(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};

jQuery(window).on('resize scroll', function() {
    // Odometer
    jQuery(".odo").each(function() {
        if(isInViewport(jQuery(this))) {
            var odometer = new Odometer({
                el: jQuery(this)[0]
            });
            odometer.update(jQuery(this).data('final-number'));
        }
    });

});